import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60316e14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-title" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("下一题 ")

import {storeToRefs} from "pinia"
import {reactive, ref} from "vue"
import {usePageStore} from "@/store"
import {Button as VanButton, Cell as VanCell, CellGroup as VanCellGroup, Image as VanImage, Toast} from "vant"

import "vant/es/cell-group/style"
import "vant/es/cell/style"
import "vant/es/button/style"
import {AnswerType, FieldItemType} from "@/dataType";


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionPage',
  setup(__props) {


const pageStore = usePageStore()
const pageStroeRef = storeToRefs(pageStore)
const { answers } = pageStroeRef

const currIndex = ref<number>(0)
const currSelect = ref<number[]>([-1])
const currAnswer =  reactive<AnswerType>(pageStore.answers[currIndex.value])
const itemArr = ref<string[]>(['A、','B、','C、','D、'])
// 锁定下一题按钮
const lockNextBtn = ref<boolean>(false)

// 选项点击
function onCheck(index: number|string) {
  if (lockNextBtn.value) return
  if (typeof index === 'string') {
    index = parseInt(index)
  }
  if (currAnswer.type === FieldItemType.checkbox) {
    if (currSelect.value.includes(index)) {
      currSelect.value = currSelect.value.filter(item => item !== index)
    } else {
      currSelect.value.push(index)
    }
  } else {
    currSelect.value = [index]
    onNext()
  }

}

// 下一题
function onNext() {
  const currSelectAnswer = currAnswer.answers.filter((item,index) => currSelect.value.includes(index))
  const fieldKey = `field_${currAnswer.id}`
  if (currSelect.value.length < 0) {
    Toast("请做出您的选择")
  } else {
    const len = currAnswer.answers.filter(item => item.isRight).length
    const isRight = (currSelectAnswer.length === len) && (currSelectAnswer.every(item => item.isRight))
    console.log(currSelectAnswer)
    Toast(isRight ? "您选对了！" : "您选错了！")
    lockNextBtn.value = true
    // 增加选择答案
    pageStore.postSelectAnswer(fieldKey, currSelectAnswer, isRight)
    setTimeout(() => {
      // 如果答完了就去结果页，否则再显示下一题
      if (currIndex.value+1 >= pageStore.totolSel) {
        setTimeout(() => {
          pageStore.changePage(3)
        }, 1000)
      } else {
        lockNextBtn.value = false
        currIndex.value++
        currSelect.value = [-1]
        const _currAnswer = pageStore.answers[currIndex.value]
        currAnswer.answers = _currAnswer.answers
        currAnswer.type = _currAnswer.type
        currAnswer.id = _currAnswer.id
        currAnswer.title = _currAnswer.title
      }

    }, 1500)
  }
}



return (_ctx: any,_cache: any) => {
  const _component_van_tag = _resolveComponent("van-tag")!

  return (_openBlock(), _createElementBlock("div", {
    className: "wrap",
    style: _normalizeStyle({
    backgroundImage: `url(${_unref(pageStore).pageInfo.collect?.bg_image})`
  })
  }, [
    (_unref(answers).length > 0)
      ? (_openBlock(), _createBlock(_unref(VanCellGroup), {
          key: 0,
          inset: "",
          class: "question-wrap"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(VanCell), {
              class: "titleElem",
              title: '题目：'+_unref(answers)[currIndex.value].title
            }, null, 8, ["title"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(answers)[currIndex.value].answers, (item, index) => {
              return (_openBlock(), _createBlock(_unref(VanCell), {
                class: _normalizeClass(["itemElem", {
            active: currSelect.value.includes(parseInt(index.toString()))
          }]),
                key: index,
                onClick: ($event: any) => (onCheck(index))
              }, _createSlots({ _: 2 }, [
                (currAnswer.type !== _unref(FieldItemType).image)
                  ? {
                      name: "title",
                      fn: _withCtx(() => [
                        _createElementVNode("span", _hoisted_1, _toDisplayString(itemArr.value[index]) + _toDisplayString(item.text), 1),
                        _createVNode(_component_van_tag, { type: "primary" })
                      ])
                    }
                  : {
                      name: "right-icon",
                      fn: _withCtx(() => [
                        _createVNode(_unref(VanImage), {
                          src: item.text
                        }, null, 8, ["src"])
                      ])
                    }
              ]), 1032, ["class", "onClick"]))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (currAnswer.type === _unref(FieldItemType).checkbox)
      ? (_openBlock(), _createBlock(_unref(VanButton), {
          key: 1,
          class: "nextBtn",
          icon: "share",
          type: "primary",
          size: "large",
          disabled: lockNextBtn.value,
          onClick: onNext
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["disabled"]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})